import React, { useEffect, useState } from 'react';
import { useParams, Outlet, Link, useLocation } from 'react-router-dom';
import { useMerchant } from '../contexts/MerchantContext';
import { checkTenant } from '../services/api';
import MerchantNavigation from './MerchantNavigation';
import PromoModal from './PromoModal';

const MerchantLayout = () => {
  const params = useParams();
  //const location = useLocation();
  const { merchant, loading,  fetchMerchant } = useMerchant();
  //const { error } = useMerchant();
  
  const [activeSlug, setActiveSlug] = useState(null);

  useEffect(() => {
    const resolveMerchantSlug = async () => {
      let targetSlug = params.merchantSlug;

      // === Case A: 網址已有 Slug (e.g. localhost:3000/my-shop) ===
      if (targetSlug) {
        console.log('✅ URL Slug found:', targetSlug);
        setActiveSlug(targetSlug);
        fetchMerchant(targetSlug);
        return;
      }

      // === Case B: Custom Domain 或 Localhost ===
      const hostname = window.location.hostname;
      
      // 🔴 【關鍵修正】: 強制處理 Localhost
      // 如果你在本地開發，請將 'your-dev-slug' 改成你資料庫裡真實存在的一個 slug
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
         console.log('⚠️ Localhost detected, forcing dev slug...');
         targetSlug = 'kaka-booking'; // <--- 請改成你 DB 裡真實的商戶 slug (例如 'kakatw' 或 'demo')
         
         setActiveSlug(targetSlug);
         fetchMerchant(targetSlug);
         return; 
      }

      // === Case C: 真實的 Custom Domain (Production) ===
      try {
        console.log(`📡 Calling checkTenant API for: ${hostname}`);
        const response = await checkTenant(hostname);
        
        if (response.data && response.data.slug) {
          targetSlug = response.data.slug;
          setActiveSlug(targetSlug);
          fetchMerchant(targetSlug);
        } else {
          console.error('❌ Domain not found in system');
        }
      } catch (err) {
        console.error('❌ checkTenant API Failed:', err);
      }
    };

    resolveMerchantSlug();
  }, [params.merchantSlug, fetchMerchant]);


  // ... (Loading 和 Error 狀態保持不變) ...
  if (loading) return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  if (!merchant) return <div className="flex items-center justify-center min-h-screen">Initializing...</div>;

  return (
    <div className="relative flex min-h-screen w-full flex-col bg-gray-50 dark:bg-gray-900 font-display text-text-primary">
      
      {/* === Header (Top Bar) === 
         手機版：只顯示標題
         桌機版：顯示標題 + 右側導航連結
      */}
      <header className="sticky top-0 z-40 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 shadow-sm">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-14">
            
            {/* 商戶標題 */}
            <div className="flex-shrink-0">
               <Link 
                 to={params.merchantSlug ? `/${activeSlug}` : '/'} 
                 className="flex flex-col"
               >
                 <span className="text-lg font-bold text-gray-900 dark:text-white leading-tight">
                   {merchant.name}
                 </span>
                 {merchant.description && (
                   // 手機版隱藏描述，節省空間，桌機版顯示
                   <span className="hidden sm:block text-xs text-gray-500 dark:text-gray-400">
                     {merchant.description}
                   </span>
                 )}
               </Link>
            </div>

            {/* 導航組件 (它自己會決定顯示 Desktop 還是 Mobile 樣式) */}
            {/* <MerchantNavigation merchantSlug={activeSlug} />  */}
            <MerchantNavigation merchantSlug={activeSlug || params.merchantSlug} />
          </div>
        </div>
      </header>
      
      {/* === Main Content ===
         關鍵改動：加入 pb-20 (Padding Bottom 5rem) 
         這是為了確保內容不會被 Fixed Bottom Nav 遮住
      */}
      <main className="flex-1 w-full max-w-md mx-auto px-4 py-6 pb-24 md:pb-8">
        <Outlet context={{ merchantSlug: activeSlug, merchantData: merchant }} />
      </main>

      <PromoModal merchantSlug={activeSlug} />

    </div>
  );
};

export default MerchantLayout;